import { Route, Routes } from 'react-router-dom'
import { CadastroProduto } from '../pages/Financeiro/CadastroProdutos'
import { UpdateProductInfo } from '../pages/Financeiro/CadastroProdutos/UpdateProductInfo'
import { ControleImposto } from '../pages/Financeiro/ControleImposto'
import { ControlePagamentos } from '../pages/Financeiro/ControlePagamentos'
import { ImpressaoPedidoCompra } from '../pages/Financeiro/ImpressaoPedidoCompra'
import { ControleContabilidade } from '../pages/Financeiro/ControleContabilidade'
import { AcompanhamentoVale } from '../pages/Financeiro/AcompanhamentoVale'
import { DescontosPendentes } from '../pages/Financeiro/DescontosPendentes'
import { FechamentoFrete } from '../pages/Financeiro/FechamentoFrete'
import { BuscarPedido } from '../pages/Financeiro/BuscarPedido'
import { ImpostoCompra } from '../pages/Financeiro/ImpostoCompra'
import { ControleKangu } from '../pages/Relatorios/ControleKangu'
import { EditarProduto } from '../pages/Financeiro/EditarProduto'
import { HistoricoPagamento } from '../pages/Financeiro/HistoricoPagamento'
import { FormEditarProduto } from '../pages/Financeiro/EditarProduto/FormEditarProduto'
import { HistoricoCadastroProduto } from '../pages/Financeiro/HistoricoCadastroProduto'
import { AtualizacaoProdutosAsiaSP } from '../pages/Financeiro/AtualizacaoProdutosAsiaSP'
import { AuditoriaFrete } from '../pages/Financeiro/AuditoriaFrete'
import { UploadLuga } from '../pages/Financeiro/UploadLuga'
import { RelatorioDeImposto } from '../pages/Financeiro/RelatorioDeImposto'
import { ValidacaoDeNf } from '../pages/Financeiro/ValidacaoDeNf'
import { EnviarPedidoDeCompra } from '../pages/Financeiro/EnviarPedidoDeCompra'
import { PedidoSpot } from '../pages/Financeiro/PedidoSpot'
import { ConferirTodosOsProdutos } from '../pages/Financeiro/ConferirTodosOsProdutos'

export function RouteFinanceiro() {
  return (
    <Routes>
      <Route path="/cadastro-produto" element={<CadastroProduto />} />
      <Route path="/cadastro-produto/:id" element={<UpdateProductInfo />} />
      <Route path="/controle-imposto" element={<ControleImposto />} />
      <Route path="/controle-pagamentos" element={<ControlePagamentos />} />
      <Route path="/impressao-pedido-compra" element={<ImpressaoPedidoCompra />} />
      <Route path="/controle-contabilidade" element={<ControleContabilidade />} />
      <Route path="/acompanhamento-vale" element={<AcompanhamentoVale />} />
      <Route path="/descontos-pendentes" element={<DescontosPendentes />} />
      {/* <Route path="/validacao-nf-compra" element={<ValidacaoNFCompra />} /> */}
      <Route path="/fechamento-frete" element={<FechamentoFrete />} />
      <Route path="/buscar-pedido" element={<BuscarPedido />} />
      <Route path="/imposto-compra" element={<ImpostoCompra />} />
      <Route path="/controle-kangu" element={<ControleKangu />} />
      <Route path="/editar-produto" element={<EditarProduto />} />
      <Route path="/editar-produto/:id" element={<FormEditarProduto />} />
      <Route path="/historico-pagamento" element={<HistoricoPagamento />} />
      <Route path="/historico-cadastro-produto" element={<HistoricoCadastroProduto />} />
      <Route path="/atualizacao-produtos-asia-sp" element={<AtualizacaoProdutosAsiaSP />} />
      <Route path="/auditoria-frete" element={<AuditoriaFrete />} />
      <Route path="planilha-luga" element={<UploadLuga />} />
      <Route path="relatorio-de-imposto" element={<RelatorioDeImposto />} />
      <Route path="validacao-de-nf" element={<ValidacaoDeNf />} />
      <Route path="enviar-pedido-compra" element={<EnviarPedidoDeCompra />} />
      <Route path="pedido-spot" element={<PedidoSpot />} />
      <Route path="conferir-todos-produtos" element={<ConferirTodosOsProdutos />} />
    </Routes>
  )
}
